<template>
  <div>
    <v-row>
      <v-col cols="12" align="center" justify="center">
        <v-img :src="image">
          <br />
          <br />
          <br />
          <h1 class="white--text">PAGE NOT FOUND</h1>
          <h2 class="white--text">This page either no longer exists or never did at all.</h2>
          <br />
          <h3>
            <router-link to="/" class="white--text">Go home Frodo</router-link>
          </h3>
        </v-img>
      </v-col>
    </v-row>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        image: require('../assets/404-page-not-found.jpg')
      }
    }
  }
</script>